import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchServices = () => api.get("/services").then((r) => r.data.services);
export const fetchPois = () => api.get("/pois").then((r) => r.data.pois);
export const fetchAvailability = () => api.get("/bookings/availability").then((r) => r.data.booked);
export const createBooking = (payload) => api.post("/bookings", payload).then((r) => r.data);
export const sendContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const fetchQuote = (service_id, booking_date, pickup_time) =>
  api.post("/quote", { service_id, booking_date, pickup_time }).then((r) => r.data);
export const fetchReviews = () => api.get("/reviews").then((r) => r.data);
export const submitReview = (payload) => api.post("/reviews/submit", payload).then((r) => r.data);
